import { createId } from "@paralleldrive/cuid2";
export var LectureStatus;
(function (LectureStatus) {
    LectureStatus["Created"] = "Created";
    LectureStatus["Started"] = "Started";
    LectureStatus["Completed"] = "Completed";
})(LectureStatus || (LectureStatus = {}));
export class Lecture {
    id;
    title;
    teacherId; // Can be null when created
    firstName; // Can be null when created
    lastName; // Can be null when created
    classroomId;
    topicIds;
    weekNumber;
    lectureDate;
    lectureEndDate;
    status;
    tournamentId;
    attendanceRecords;
    constructor(data) {
        this.id = createId();
        this.title = data.title;
        this.teacherId = data.teacherId;
        this.firstName = data.firstName;
        this.lastName = data.lastName;
        this.classroomId = data.classroomId;
        this.topicIds = data.topicIds;
        this.weekNumber = data.weekNumber;
        this.lectureDate = data.lectureDate;
        this.lectureEndDate = data.lectureEndDate;
        this.status = data.status;
        this.tournamentId = data.tournamentId;
        this.attendanceRecords = [];
    }
    update(data) {
        if (data.classroomId !== undefined)
            this.classroomId = data.classroomId;
        if (data.topicIds !== undefined)
            this.topicIds = data.topicIds;
        if (data.weekNumber !== undefined)
            this.weekNumber = data.weekNumber;
        if (data.lectureDate !== undefined)
            this.lectureDate = data.lectureDate;
        if (data.lectureEndDate !== undefined)
            this.lectureEndDate = data.lectureEndDate;
    }
    start(teacherId) {
        if (this.status !== LectureStatus.Created) {
            throw new Error("Lecture can only be started when in Created status");
        }
        this.teacherId = teacherId;
        this.status = LectureStatus.Started;
    }
    complete() {
        if (this.status !== LectureStatus.Started) {
            throw new Error("Lecture can only be completed when in Started status");
        }
        this.status = LectureStatus.Completed;
    }
    addTopic(topicId) {
        if (this.status === LectureStatus.Completed) {
            throw new Error("Cannot modify topics in a completed lecture");
        }
        if (!this.topicIds) {
            this.topicIds = [];
        }
        if (!this.topicIds.includes(topicId)) {
            this.topicIds.push(topicId);
        }
    }
    removeTopic(topicId) {
        if (this.status === LectureStatus.Completed) {
            throw new Error("Cannot modify topics in a completed lecture");
        }
        if (!this.topicIds) {
            return;
        }
        this.topicIds = this.topicIds.filter((id) => id !== topicId);
    }
    setAttendanceRecords(records) {
        if (this.status !== LectureStatus.Started) {
            throw new Error("Attendance can only be set during started lecture");
        }
        this.attendanceRecords = records;
    }
}
